/**
 * Ryan O'Dowd
 * 2024-09-22
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  TouchableOpacity,
  View,
} from 'react-native';
import Icon from '@react-native-vector-icons/material-design-icons';
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const Header = (props: HeaderProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.touchable}
        disabled={!props.onPress}
        onPress={() => props.onPress()}
      >
        <Text style={styles.brickTitle}>
          {props.title}
        </Text>
      </TouchableOpacity>
      {props.rightComponent}
      {!!(props.rightIconName && props.onPressRightIcon) &&
        <Icon
          style={styles.actionIcon}
          name={props.rightIconName}
          color={styles.colors.brickTitle}
          onPress={() => props.onPressRightIcon()}
        />
      }
    </View>
  );
};

class HeaderProps {
  title: string;

  navigation?: any; // @TODO: sure this is optional?
  complete?: boolean;
  onPress?: () => void;
  rightComponent?: React.ReactNode;
  rightIconName?: any;
  onPressRightIcon?: () => void;
};

export default Header;
